'use client'
import { useEffect } from 'react'
import increaseViewCount from '@/travelmde/utilities/increaseViewCount'

const IncreaseCountClientSide = ({ lang, collection, itemId, title }) => {
  useEffect(() => {
    // Skip if missing required props
    if (!lang || !collection || !itemId) {
      return
    }

    // Use a timeout to avoid race conditions with page load
    const timer = setTimeout(async () => {
      try {
        await increaseViewCount(lang, collection, itemId, title)
      } catch (error) {
        // Only log in development
        if (process.env.NODE_ENV === 'development') {
          console.error('View count error:', error)
        }
      }
    }, 2000) // Increased delay to ensure page is fully loaded

    return () => clearTimeout(timer)
  }, [lang, collection, itemId, title])

  return null
}

export default IncreaseCountClientSide
